import React from 'react'

import { node } from 'prop-types'

import * as S from './styled'

const SectionContent = ({ children, className, ...rest }) => (
  <S.SectionContentWrapper className={className} {...rest}>
    {children}
  </S.SectionContentWrapper>
)

SectionContent.propTypes = {
  children: node,
}

export default SectionContent
